export default __webpack_public_path__ + "static/media/coming-soon.58c6b560.svg";